var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow",staticStyle:{"padding":"15px 30px","width":"100%"}},[_c('div',{ref:"scanActivityByDay",staticClass:"chartStyle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }